<template>
  <Collapsible compact defaultOpen class="CartSubscriptionSection">
    <template #header>
      <p class="CartSubscriptionSection-title">
        {{ title }}
      </p>
    </template>

    <template #content>
      <div class="CartSubscriptionSection-content">
        <template v-if="items">
          <CartSubscriptionItem
            v-for="item of items"
            :key="item.id ?? item.name"
            :label="item.name"
            :value="item.value"
            :originalValue="item.originalValue"
            :tag="item.promo ? promoTagLabel : undefined"
            :description="item.description"
            :quantity="item.quantity"
          />
        </template>

        <slot v-else />
      </div>
    </template>
  </Collapsible>
</template>

<script setup lang="ts">
import Collapsible from '../../molecules/Collapsible/Collapsible.vue';
import type { CartSubscriptionSectionProps } from './CartSubscription.model';
import CartSubscriptionItem from './CartSubscriptionItem.vue';

defineProps<CartSubscriptionSectionProps>();
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .CartSubscriptionSection {
    border-top: vars.$organisms-cart-cart-border-stroke solid vars.$organisms-cart-cart-border-color;
    border-radius: 0;

    .Collapsible-header {
      padding: vars.$dimensions-d-4 0;
    }

    // Hides the default horizontal divider between section header and content
    .Collapsible-divider {
      display: none;
    }

    &-title {
      color: vars.$organisms-cart-cart-primary-text-color;
      @include text.text(sm);

      font-weight: vars.$typography-weight-strong;
    }

    &-content {
      display: flex;
      flex-direction: column;
      gap: vars.$dimensions-d-4;
      padding-bottom: vars.$dimensions-d-4;
    }
  }
}
</style>
